export default __webpack_public_path__ + "static/media/intro.d2e0a15f.webp";